/* Visar footern på sidan */
import React from "react";
import Version from "../Version";
import logo from '../Components/logo.png';

const Footer = (props) => {
    let mode = "web";
    if (window.matchMedia('(display-mode: standalone)').matches) {
        mode = "sa";
    }
    return (
        <table>
            <tbody>
                <tr>
                    <td rowSpan={2}>
                        <img
                            height={"70px"}
                            src={logo}
                            alt="Logo" />

                    </td>
                    <td>
                        <span
                            style={{
                                color: "grey",
                                fontSize: "75%",
                                fontStyle: "italic"
                            }}>
                            <a href='https://kjell.haxx.se/'>Copyright Kjell.Ericson@haxx.se</a>.
                            <br />
                            Data från Resrobot.se.
                            <br />
                            {Version}
                            &nbsp;&nbsp;
                            ({mode})
                        </span>

                    </td>
                </tr>
            </tbody>
        </table>
    )
}


export default Footer;